/* eslint-disable no-underscore-dangle */ // we use __ to indicate a private global variable

// Bundler(webpack, for now) introduces some subtle challenge
// Like every package could only be accessed by webpack itself.
// Seems reasonable, but this means, the tests(run in node) could not use any packages in browser though import statement or expression.
// For example, if you are using playwright:
/**
 * const status = await page.evaluate(async () => {
 *   const somepackage = await import('somePackage');
 *   // 'somePackage' is used in your application
 *   // but this will throw an error, because 'somePackage' was taken over by webpack
 * });
 */

// So, this introduce a context, which just give a global context under window, so the test could access it directly
// TODO: It's not a best solution, it makes tree shaking workless! Should be removed in future if we have resource to do it.

import edmImport from '@bingads-webui-component-legacy/edm-campaign/index';
import jsDataCampaignImport from '@bingads-webui-component-legacy/js-data-campaign/index';
import exRepoImport from '@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository';
import * as azurePayloadImport from '@bingads-webui/azure-upload';
import * as EDMCampaign from '@bingads-webui/edm-campaign';
import componentStateImport from '@bingads-webui-component-legacy/state/index';
import legacyOdataImport from '@bingads-webui-component-legacy/http/channel/odata';
import hotelCenterJsDataImport from '@bingads-webui-campaign-legacy/hotel-center-js-data/index';
import hotelCenterEDMImport from '@bingads-webui-campaign-legacy/hotel-center-edm/index';
import legacyPreferenceImport from '@bingads-webui-component-legacy/preference/service/index';
import PageContext from '@bingads-webui-static-legacy/page-context';
import OdataAdapter from '@bingads-webui-component-legacy/js-data-odata/index';

export function setTestContext() {
  if (window.__integration_test_packages_escape_hatch__) {
    return;
  }

  window.__integration_test_packages_escape_hatch__ = {};
  window.__integration_test_packages_escape_hatch__['@bingads-webui-component-legacy/edm-campaign/index'] = edmImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-component-legacy/js-data-campaign/index'] = jsDataCampaignImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-campaign-legacy/advanced-settings/util/exclusion-repository'] = exRepoImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui/azure-upload'] = azurePayloadImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui/edm-campaign'] = EDMCampaign;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-component-legacy/state/index'] = componentStateImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-component-legacy/http/channel/odata'] = legacyOdataImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-campaign-legacy/hotel-center-js-data/index'] = hotelCenterJsDataImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-campaign-legacy/hotel-center-edm/index'] = hotelCenterEDMImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-component-legacy/preference/service/index'] = legacyPreferenceImport;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-static-legacy/page-context'] = PageContext;
  window.__integration_test_packages_escape_hatch__['@bingads-webui-component-legacy/js-data-odata/index'] = OdataAdapter;
}
